import VueRouter, { RouteConfig } from 'vue-router';
import NotFound from '@/views/NotFound.vue';
import auth from './auth';
import profile from './profile';
import dashboard from './dashboard';
import user from './user';
import oversight from './oversight';
import provider from './provider';
import role from './role';
import survey from './survey';
import email from './email';
import functionalcenter from './functionalcenter';
import worksheet from './worksheet';
import resources from './resources';
import dataset from './dataset';
import useragreement from './useragreement';
import notification from './notification';
import deployment from "./deployment";

const withPrefix = (prefix: string, routes: RouteConfig[]) => {
  return routes.map((route) => {
    route.path = prefix + route.path;
    return route;
  });
};

export default [
  auth,
  profile,
  dashboard,
  user,
  oversight,
  provider,
  role,
  survey,
  email,
  functionalcenter,
  worksheet,
  resources,
  dataset,
  useragreement,
  notification,
  deployment,
  (router: VueRouter): RouteConfig[] => {
    return [
      {
        path: '/',
        redirect: { name: 'dashboard' },
      },
      {
        path: '/contact-info',
        name: 'contact-info',
        component: () => import('@/views/deployment/ContactInfo.vue')
      },
      {
        path: '/logs',
        name: 'logs',
        component: () => import('@/views/Logs.vue'),
      },
      {
        path: '/:id(\\d+)',
        name: 'logs-edit',
        component: () => import('@/views/LogsEdit.vue'),
      },
      {
        path: '*',
        name: '404',
        component: NotFound,
      },
    ];
  },
];
export { withPrefix };
